export default "__VITE_ASSET__CqkEsMCi__"